export const helpIds = {};

export const HELP_PAGE_NOT_FOUND_ID = 0;
